module.exports = ".headerbackcolor\r\n{\r\n    background-color: #ccc;\r\n}\r\n\r\n.redmark\r\n{\r\n    color: red;\r\n}"